export const FAVORITE_DOC_LOADING = "FAVORITE_DOC_LOADING";
export const FAVORITE_DOC_SUCCESS = "FAVORITE_DOC_SUCCESS";
export const FAVORITE_DOC_ERROR = "FAVORITE_DOC_ERROR";
